"use client";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";

const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: { main: "#B5202A", dark: "#C94048" },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI Variable"',
      '"Segoe UI"',
      "system-ui",
      "ui-sans-serif",
      "Helvetica",
      "Arial",
      "sans-serif",
    ].join(","),
  },
});

export default function ThemeRegistry({ children }: { children: ReactNode }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
